import { Component, EventEmitter, OnInit, Input, Output, ViewChild, ViewChildren, QueryList } from '@angular/core';
import { AppModule }              from '../app.module';

import * as ent from '../entities/index'
import * as serv from '../services/index'
import * as enums from '../enums/index'

//base
import { BaseDropdownComponent } from '../baseclasses/BaseDropdown.component';




export abstract class BaseEditComponent implements OnInit{
    userInfo: ent.UserInfo;
    enableCustomerLookups: boolean;
    enableEquipmentLookups: boolean;
    private authenticationService: serv.AuthenticationService;
    ngOnInit() {};

    constructor(){
        this.authenticationService = AppModule.injector.get(serv.AuthenticationService);
        this.userInfo = this.authenticationService.getUserInfo();
        this.enableCustomerLookups = this.userInfo.AppSettings.filter(x=>x.ID == enums.AppSettingEnum.EnableCustomerLookups)[0].SettingValue == "true" ? true : false;
        this.enableEquipmentLookups = this.userInfo.AppSettings.filter(x=>x.ID == enums.AppSettingEnum.EnableEquipmentLookups)[0].SettingValue == "true" ? true : false;

    }

    public customerLookupsEnabled(): boolean {
        return this.enableCustomerLookups;
        
    }
    public equipmentLookupsEnabled(): boolean {
        
        return this.enableEquipmentLookups;
    }

    @ViewChildren(BaseDropdownComponent) dropDowns: QueryList<BaseDropdownComponent>;
    
    public loadDropDowns(){
        if (this.dropDowns){
            var dropdowns = this.dropDowns.toArray();
            
            for (var dropdown of dropdowns){
                dropdown.load();
            }
        }
    }


}

export default BaseEditComponent;